const puzzle = {
  id: "vF94jf72ks0127nQNqfr",
  name: "Emoji titles",
  rebuses: [
    {
      clues: [
        {
          clueGroup: 0,
          id: "baf1f937-dafe-49a5-bfe9-3320c267d718",
          style: { width: "calc(33% - 10px)" },
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/44a.png",
              id: "ff2fc50e-5f95-4a9c-8057-ffeefba9fbd9",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          solutionInfo: {
            solvedText: "Squid Game",
            type: "text",
            possibleSolutions: [
              { value: "Squid Game", id: "n4fsdx-06be-43a2-9b11-b1e09076b5e9" },
            ],
          },
          helperText: "",
          subtext: "",
          dependsOn: [],
        },
        {
          style: { width: "calc(33% - 10px)" },
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/40a.png",
              subtext: "",
              style: { width: "calc(100% - 10px)" },
              id: "ccdd377c-e3a9-4da0-af5a-c11d6c8a1cc5",
            },
          ],
          dependsOn: [],
          clueGroup: 0,
          subtext: "",
          solutionInfo: {
            solvedText: "Money Heist",
            possibleSolutions: [
              {
                value: "Money Heist",
                id: "b23A35-nd31-43a2-9b11-b1e09076b5e9",
              },
            ],
            type: "text",
          },
          helperText: "",
          id: "9c20813d-4253-4a17-b70f-2bcea9d7e1e7",
        },
        {
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/41a.png",
              subtext: "",
              id: "6d5a8ac4-963a-461d-9be5-ca5d58b7fe46",
              style: { width: "calc(100% - 10px)" },
            },
          ],
          clueGroup: 0,
          dependsOn: [],
          helperText: "",
          id: "9485250b-1b39-4fdf-9348-2417e9579a43",
          subtext: "",
          style: { width: "calc(33% - 10px)" },
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "The Queen's Gambit",
                id: "111111-nd31-43a2-9b11-b1e09076b5e9",
              },
              {
                value: "Queen's Gambit",
                id: "222222-nd31-43a2-9b11-b1e09076b5e9",
              },
              {
                value: "Queens Gambit",
                id: "333333-nd31-43a2-9b11-b1e09076b5e9",
              },
              {
                value: "The Queens Gambit",
                id: "4444444-nd31-43a2-9b11-b1e09076b5e9",
              },
            ],
            solvedText: "The Queen's Gambit",
          },
        },
      ],
      style: {},
      solutionInfo: {
        solvedText: "Netflix",
        possibleSolutions: [
          { value: "Netflix", id: "af18d849-06be-43a2-9b11-b1e09076b5e9" },
        ],
        type: "text",
      },
      id: "0b3e0940-76b4-475a-b340-311d485625e2",
    },
    {
      clues: [
        {
          clueGroup: 0,
          id: "111111-mjzjj-49a5-bfe9-3320c267d718",
          style: { width: "calc(50% - 10px)" },
          clueValues: [
            {
              id: "ff2fc50e-5f95-4a9c-8057-ffeefba9fbd9",
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/42a.png",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          solutionInfo: {
            solvedText: "Ratatouille",
            type: "text",
            possibleSolutions: [
              {
                value: "Ratatouille",
                id: "n4fsdx-06be-43a2-9b11-b1e09076b5e9",
              },
            ],
          },
          helperText: "",
          subtext: "",
          dependsOn: [],
        },
        {
          style: { width: "calc(50% - 10px)" },
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/46a.png",
              subtext: "",
              style: { width: "calc(100% - 10px)" },
              id: "ccdd377c-e3a9-4da0-af5a-c11d6c8a1cc5",
            },
          ],
          dependsOn: [],
          clueGroup: 0,
          subtext: "",
          solutionInfo: {
            solvedText: "Up",
            possibleSolutions: [
              { value: "Up", id: "b23A35-nd31-43a2-9b11-b1e09076b5e9" },
            ],
            type: "text",
          },
          helperText: "",
          id: "9c20813d-nhtgnhtg-4a17-b70f-2bcea9d7e1e7",
        },
        {
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/34a.png",
              subtext: "",
              id: "6d5a8ac4-33qa-461d-9be5-ca5d58b7fe46",
              style: { width: "calc(100% - 10px)" },
            },
          ],
          clueGroup: 0,
          dependsOn: [],
          helperText: "",
          id: "9485250b-1b39-gfgf-9348-2417e9579a43",
          subtext: "",
          style: { width: "calc(50% - 10px)" },
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "Finding Nemo",
                id: "111111-mmmm-43a2-9b11-b1e09076b5e9",
              },
            ],
            solvedText: "Finding Nemo",
          },
        },
      ],
      style: {},
      solutionInfo: {
        solvedText: "Pixar",
        possibleSolutions: [
          { value: "Pixar", id: "af18d849-06be-43a2-9b11-b1e09076b5e9" },
        ],
        type: "text",
      },
      id: "222222-vdsd-475a-b340-311d485625e2",
    },
    {
      clues: [
        {
          clueGroup: 0,
          id: "4534-mjzjj-49a5-bfe9-3320c267d718",
          style: { width: "calc(33% - 10px)" },
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/45a.png",
              id: "87687-5f95-4a9c-8057-ffeefba9fbd9",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          solutionInfo: {
            solvedText: "Thor",
            type: "text",
            possibleSolutions: [
              { value: "Thor", id: "87987-06be-43a2-9b11-b1e09076b5e9" },
            ],
          },
          helperText: "",
          subtext: "",
          dependsOn: [],
        },
        {
          style: { width: "calc(33% - 10px)" },
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/38a.png",
              subtext: "",
              style: { width: "calc(100% - 10px)" },
              id: "ccdd377c-e3a9-6655-af5a-c11d6c8a1cc5",
            },
          ],
          dependsOn: [],
          clueGroup: 0,
          subtext: "",
          solutionInfo: {
            solvedText: "The Incredible Hulk",
            possibleSolutions: [
              {
                value: "The Incredible Hulk",
                id: "b23A35-2234-43a2-9b11-b1e09076b5e9",
              },
              { value: "Hulk", id: "u7657-2234-43a2-9b11-b1e09076b5e9" },
            ],
            type: "text",
          },
          helperText: "",
          id: "9c20813d-gfdd-4a17-b70f-2bcea9d7e1e7",
        },
        {
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/39a.png",
              subtext: "",
              id: "1s34-33qa-461d-9be5-ca5d58b7fe46",
              style: { width: "calc(100% - 10px)" },
            },
          ],
          clueGroup: 0,
          dependsOn: [],
          helperText: "",
          id: "98797-1b39-gfgf-9348-2417e9579a43",
          subtext: "",
          style: { width: "calc(33% - 10px)" },
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              { value: "Ironman", id: "bntff-mmmm-43a2-9b11-b1e09076b5e9" },
              { value: "Iron Man", id: "mnbfgf-mmmm-43a2-9b11-b1e09076b5e9" },
            ],
            solvedText: "Iron Man",
          },
        },
        {
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/36a.png",
              subtext: "",
              id: "1s34-33qa-461d-9be5-ca5d58b7fe46",
              style: { width: "calc(100% - 10px)" },
            },
          ],
          clueGroup: 0,
          dependsOn: [],
          helperText: "",
          id: "111-1b39-gfgf-9348-4322",
          subtext: "",
          style: { width: "calc(33% - 10px)" },
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "Ghost Rider",
                id: "bntff-4eedd-43a2-9b11-b1e09076b5e9",
              },
            ],
            solvedText: "Ghost Rider",
          },
        },
        {
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/32a.png",
              subtext: "",
              id: "ht4rhnmu-33qa-461d-9be5-ca5d58b7fe46",
              style: { width: "calc(100% - 10px)" },
            },
          ],
          clueGroup: 0,
          dependsOn: [],
          helperText: "",
          id: "uiuiui-1b39-gfgf-9348-4322",
          subtext: "",
          style: { width: "calc(33% - 10px)" },
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "Doctor Strange",
                id: "klklklk-4eedd-43a2-9b11-b1e09076b5e9",
              },
              {
                value: "Dr Strange",
                id: "hjhjhjhjh-4eedd-43a2-9b11-b1e09076b5e9",
              },
              {
                value: "Dr. Strange",
                id: "ghfffssss-4eedd-43a2-9b11-b1e09076b5e9",
              },
            ],
            solvedText: "Doctor Strange",
          },
        },
        {
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/31a.png",
              subtext: "",
              id: "otototo-33qa-461d-9be5-ca5d58b7fe46",
              style: { width: "calc(100% - 10px)" },
            },
          ],
          clueGroup: 0,
          dependsOn: [],
          helperText: "",
          id: "atatatat-1b39-gfgf-9348-4322",
          subtext: "",
          style: { width: "calc(33% - 10px)" },
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              { value: "Deadpool", id: "bnbnbnb-4eedd-43a2-9b11-b1e09076b5e9" },
            ],
            solvedText: "Deadpool",
          },
        },
      ],
      style: {},
      solutionInfo: {
        solvedText: "Marvel",
        possibleSolutions: [
          { value: "Marvel", id: "fhfhfhf-06be-43a2-9b11-b1e09076b5e9" },
        ],
        type: "text",
      },
      id: "kfiww-vdsd-475a-b340-311d485625e2",
    },
    {
      clues: [
        {
          clueGroup: 0,
          id: "qzqzqzq-dafe-49a5-bfe9-3320c267d718",
          style: { width: "calc(33% - 10px)" },
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/43a.png",
              id: "tutututut-5f95-4a9c-8057-ffeefba9fbd9",
              style: { width: "calc(100% - 10px)" },
              subtext: "",
            },
          ],
          solutionInfo: {
            solvedText: "Silence of the Lambs",
            type: "text",
            possibleSolutions: [
              {
                value: "Silence of the Lambs",
                id: "qpoqoqoqo-06be-43a2-9b11-b1e09076b5e9",
              },
            ],
          },
          helperText: "",
          subtext: "",
          dependsOn: [],
        },
        {
          style: { width: "calc(33% - 10px)" },
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/33a.png",
              subtext: "",
              style: { width: "calc(100% - 10px)" },
              id: "qwxhhn-e3a9-4da0-af5a-c11d6c8a1cc5",
            },
          ],
          dependsOn: [],
          clueGroup: 0,
          subtext: "",
          solutionInfo: {
            solvedText: "Doctor Who",
            possibleSolutions: [
              {
                value: "Doctor Who",
                id: "tzretew-nd31-43a2-9b11-b1e09076b5e9",
              },
              { value: "Dr Who", id: "2543-nd31-43a2-9b11-b1e09076b5e9" },
              { value: "Dr. Who", id: "2543-nd31-43a2-9b11-b1e09076b5e9" },
            ],
            type: "text",
          },
          helperText: "",
          id: "ewass-4253-4a17-b70f-2bcea9d7e1e7",
        },
        {
          style: { width: "calc(33% - 10px)" },
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/47a.png",
              subtext: "",
              style: { width: "calc(100% - 10px)" },
              id: "vbvgvgdfhd-e3a9-4da0-af5a-c11d6c8a1cc5",
            },
          ],
          dependsOn: [],
          clueGroup: 0,
          subtext: "",
          solutionInfo: {
            solvedText: "The Wolf of Wall Street",
            possibleSolutions: [
              {
                value: "The Wolf of Wall Street",
                id: "quqjsb-nd31-43a2-9b11-b1e09076b5e9",
              },
              {
                value: "Wolf of Wall Street",
                id: "nfvnfgf-nd31-43a2-9b11-b1e09076b5e9",
              },
            ],
            type: "text",
          },
          helperText: "",
          id: "cvusjha-4253-4a17-b70f-2bcea9d7e1e7",
        },
        {
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/30a.png",
              subtext: "",
              id: "sadasda-963a-461d-9be5-ca5d58b7fe46",
              style: { width: "calc(100% - 10px)" },
            },
          ],
          clueGroup: 0,
          dependsOn: [],
          helperText: "",
          id: "qweqweq-1b39-4fdf-9348-2417e9579a43",
          subtext: "",
          style: { width: "calc(33% - 10px)" },
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "Back to the Future",
                id: "t3t-nd31-43a2-9b11-b1e09076b5e9",
              },
            ],
            solvedText: "Back to the Future",
          },
        },
        {
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/35a.png",
              subtext: "",
              id: "rrrttt-963a-461d-9be5-ca5d58b7fe46",
              style: { width: "calc(100% - 10px)" },
            },
          ],
          clueGroup: 0,
          dependsOn: [],
          helperText: "",
          id: "uttttr-1b39-4fdf-9348-2417e9579a43",
          subtext: "",
          style: { width: "calc(33% - 10px)" },
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "Game of Thrones",
                id: "jtztztztzt-nd31-43a2-9b11-b1e09076b5e9",
              },
            ],
            solvedText: "Game of Thrones",
          },
        },
        {
          clueValues: [
            {
              type: "image",
              value: "workshop/vF94jf72ks0127nQNqfr/37a.png",
              subtext: "",
              id: "ntttr-963a-461d-9be5-ca5d58b7fe46",
              style: { width: "calc(100% - 10px)" },
            },
          ],
          clueGroup: 0,
          dependsOn: [],
          helperText: "",
          id: "weeeet-1b39-4fdf-9348-2417e9579a43",
          subtext: "",
          style: { width: "calc(33% - 10px)" },
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              { value: "Home Alone", id: "qwwwwq-nd31-43a2-9b11-b1e09076b5e9" },
            ],
            solvedText: "Home Alone",
          },
        },
      ],
      style: {},
      solutionInfo: {
        solvedText: "Solved!",
        possibleSolutions: [],
        type: "text",
      },
      id: "1122-76b4-475a-b340-311d485625e2",
      isUnlocked: true,
    },
  ],
};

export default puzzle;
